import * as React from 'react'
import styled, { css } from '@xstyled/styled-components'

interface ButtonElementProps {
  disabled?: boolean
}
const ButtonElement = styled.button<ButtonElementProps>`
  ${({ disabled }) => css`
    opacity: ${disabled ? 0.6 : 1};
    pointer-events: ${disabled ? 'none' : 'auto'};
    font-size: 18px;
    border: 1px solid #e0b855;
    border-radius: 4px;
    padding: 2px 8px;
    background-color: rgba(255, 255, 255, 0.5);
    margin-top: 1rem;
  `}
`

interface ButtonProps {
  onClick?: () => void
  type?: 'submit' | 'button'
  label?: string | null
  disabled?: boolean
}

export const Button: React.FC<ButtonProps> = ({
  disabled,
  onClick,
  type,
  label,
}) => (
  <ButtonElement disabled={disabled} onClick={onClick} type={type || 'button'}>
    {label}
  </ButtonElement>
)
